import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

export class Roles {
  constructor(public roles: string[]) { }
}
export interface roles {
  isAdmin?: boolean;
  isUser?: boolean;
}
@Injectable({
  providedIn: 'root',
})
export class RolesService {
  getRoles(): { roleId?: string; roleName: any }[] {
    const userRole = localStorage.getItem('role');
    return userRole ? JSON.parse(userRole) : [];
  }

  isUserInRoles(roleName: any): boolean {
    const userRoles = this.getRoles();
    if (userRoles.some((role) => role.roleName === roleName)) {
      return true;
    } else {
      return false;
    }
  }
  private userRoles: string[] = [];

  setRoles(roles: string[]): void {
    this.userRoles = roles;
    localStorage.setItem('userRoles', JSON.stringify(this.userRoles));
    if((this.userRoles.filter((role:any) => role.includes('AMR')))&& (this.userRoles.filter((role:any) => role.includes('IDN')))){
      localStorage.setItem('selectedRole', 'AMR');
    }

  }

  getUserRolesFromLocalStorage(): any[] | null {
    const URoles = localStorage.getItem('role');
    return URoles ? JSON.parse(URoles) : null;
  }
  hasAllRole(requiredRoles: any[]): boolean {
    const storedRoles = this.getUserRolesFromLocalStorage();
    if (storedRoles) {
      const result = requiredRoles.every((requiredRole) =>
        storedRoles.some((role) => role.roleName === requiredRole)
      );
      return result;
    } else {
      return false;
    }
  }

  hasRole(roleName: string): boolean {
    const storedRoles = this.getUserRolesFromLocalStorage();
    return storedRoles
      ? storedRoles.some((role) => role.roleName === roleName)
      : false;
  }

  adminRole(): boolean {
    return this.hasRole('admin');
  }
  CDDUser(): boolean {
    return this.hasRole('IDN - CDD User');
  }
  
  CDDBasicUser(): boolean {
    return this.hasRole('IDN - CDD Basic User');
  }
  mutipleRole(): boolean {
    return this.hasAllRole(['IDN - CDD Basic User', 'IDN - CDD User', 'IDN - CDD Super User']);
  }
  superCDDRole(): boolean {
    return this.hasRole('IDN - CDD Super User')
  }
  amrBasicRole(): boolean {
    return this.hasRole('AMR -  Basic User');
  }
  amrSuperRole(): boolean {
    return this.hasRole('AMR - Super User');
  }
  amrFacility(): boolean { 
    return this.hasRole('AMR - Healthcare Facility Users');
  }
  idnFacility(): boolean {
    
    return this.hasRole('IDN - Healthcare Facility User') || this.hasRole('IDN - Non Healthcare Facility Users');

  }
}
